"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _reactComponents = require("@cimpress/react-components");

var _i18n = require("../../utils/i18n");

var _ids = require("../../apis/ids");

var _helpers = require("../common/helpers");

var _SecondaryButton = _interopRequireDefault(require("../common/buttons/SecondaryButton"));

var _LatestInvoicesWidget = _interopRequireDefault(require("./LatestInvoicesWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LatestInvoicesContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(LatestInvoicesContainer, _Component);

  function LatestInvoicesContainer(props) {
    var _this;

    _classCallCheck(this, LatestInvoicesContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LatestInvoicesContainer).call(this, props));
    _this.mounted = true;
    _this.state = {
      invoices: [],
      resolvedIdentity: null
    };
    return _this;
  }

  _createClass(LatestInvoicesContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.accessToken && this.props.identity && this.props.identity.id) {
        this.loadData();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var before = {
        accessToken: prevProps.accessToken,
        identity: prevProps.identity
      };
      var after = {
        accessToken: this.props.accessToken,
        identity: this.props.identity
      };

      if (JSON.stringify(before) !== JSON.stringify(after)) {
        this.safeSetState({
          resolvedIdentity: null,
          invoices: []
        }, this.loadData);
      }
    }
  }, {
    key: "safeSetState",
    value: function safeSetState(s, callback) {
      if (this.mounted) {
        this.setState(s, callback);
      }
    }
  }, {
    key: "loadData",
    value: function () {
      var _loadData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.safeSetState({
                  loading: true
                },
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee() {
                  var resolvedIdentity, invoices;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return _this2.resolveIdentity();

                        case 3:
                          resolvedIdentity = _context.sent;
                          _context.next = 6;
                          return (0, _ids.getInvoices)(_this2.props.accessToken, resolvedIdentity);

                        case 6:
                          invoices = _context.sent;

                          _this2.safeSetState({
                            resolvedIdentity: resolvedIdentity,
                            loading: false,
                            loadingError: null,
                            invoices: invoices
                          });

                          _context.next = 13;
                          break;

                        case 10:
                          _context.prev = 10;
                          _context.t0 = _context["catch"](0);

                          _this2.safeSetState({
                            loading: false,
                            loadingError: _context.t0.message || _context.t0,
                            invoices: null
                          });

                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 10]]);
                })));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadData() {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }()
  }, {
    key: "resolveIdentity",
    value: function () {
      var _resolveIdentity = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this$props, _this$props$identity, type, id, accessToken, fulfiller;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = this.props, _this$props$identity = _this$props.identity, type = _this$props$identity.type, id = _this$props$identity.id, accessToken = _this$props.accessToken;

                if (!(type === 'Fulfiller')) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return (0, _ids.getFulfillerIdentity)(accessToken, id);

              case 4:
                fulfiller = _context3.sent;

                if (!(fulfiller.links && fulfiller.links.account)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", {
                  type: 'Account',
                  id: fulfiller.links.account.name
                });

              case 7:
                return _context3.abrupt("return", this.props.identity);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function resolveIdentity() {
        return _resolveIdentity.apply(this, arguments);
      }

      return resolveIdentity;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.loading) {
        return (0, _helpers.renderLoading)(this.props);
      }

      if (this.state.loadingError) {
        return _react["default"].createElement("div", null, _react["default"].createElement(_reactComponents.Alert, {
          message: this.state.loadingError,
          title: (0, _i18n.tt)(this.props, 'loading-failed-title'),
          dismissible: false
        }), _react["default"].createElement(_SecondaryButton["default"], {
          title: (0, _i18n.tt)(this.props, 'btn-reload-on-error'),
          onClick: function onClick() {
            _this3.loadData();
          },
          disabled: Boolean(!this.state.resolvedIdentity)
        }));
      }

      return _react["default"].createElement(_LatestInvoicesWidget["default"], _extends({}, this.props, {
        invoices: this.state.invoices,
        identity: this.state.resolvedIdentity
      }));
    }
  }]);

  return LatestInvoicesContainer;
}(_react.Component);

LatestInvoicesContainer.propTypes = {
  locale: _propTypes["default"].string,
  accessToken: _propTypes["default"].string.isRequired,
  identity: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired
  }),
  maxInvoices: _propTypes["default"].number,
  dateFormat: _propTypes["default"].string,
  showAmount: _propTypes["default"].bool,
  showLinks: _propTypes["default"].bool,
  showBuyer: _propTypes["default"].bool,
  showSeller: _propTypes["default"].bool,
  showReference: _propTypes["default"].bool,
  wrapInCardWithTitle: _propTypes["default"].bool,
  t: _propTypes["default"].func,
  // comes from withTranslation
  i18n: _propTypes["default"].any // comes from withTranslation

};
LatestInvoicesContainer.defaultProps = {
  locale: 'en',
  maxInvoices: 3,
  dateFormat: 'YYYY-MMM-DD',
  showAmount: true,
  showLinks: true,
  showBuyer: true,
  showSeller: true,
  showReference: true,
  wrapInCardWithTitle: true
};

var _default = (0, _reactI18next.withTranslation)()(LatestInvoicesContainer);

exports["default"] = _default;